import { useEffect } from 'react';

export function usePageTitle(pageName: string, itemName?: string | null) {
  const title = [itemName?.trim(), pageName, 'HubSpot Quote Tool'].filter(Boolean).join(' | ');

  useEffect(() => {
    document.title = title;
  }, [title]);
}
